import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SKIP_CUSTOM_HEADERS } from '@interacta-shared/util';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

export const CURRENT_LANGUAGE_HEADER_NAME = 'interacta-preferred-language';

@Injectable()
export class CurrentLanguageInterceptor implements HttpInterceptor {
    private readonly configurationService = inject(ConfigurationService);

    intercept(
        req: HttpRequest<unknown>,
        next: HttpHandler,
    ): Observable<HttpEvent<unknown>> {
        // Until environment-info resolves, currentLanguage() is the hardcoded
        // default, not the user's: let the backend fall back to Accept-Language.
        if (
            req.context.get(SKIP_CUSTOM_HEADERS) ||
            !this.configurationService.environmentInfo()
        ) {
            return next.handle(req);
        }

        return next.handle(
            req.clone({
                setHeaders: {
                    [CURRENT_LANGUAGE_HEADER_NAME]:
                        this.configurationService.currentLanguage().code,
                },
            }),
        );
    }
}

export const currentLanguageInterceptor: HttpInterceptorFn = (req, next) =>
    inject(CurrentLanguageInterceptor).intercept(req, { handle: next });
